<template>
<div class="devlivery-term-iasc">
  <HeaderTerm
    :imgsrc="urlImages.imgTermDelivery"
    :event-id="ticket.eventId"
    :ticket-id="ticket._id"
  />

  <div
    v-for="(i) in [1,2]"
    :key="i"
  >
    <div
      class="row"
      style="border: solid 1px black;"
    >
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-6">
            <h6>Fabricante: {{ manufacturer.name }}</h6>
          </div>
          <div class="col-xs-6">
            <h6>Concessionária: {{ abbreviation }}</h6>
          </div>
          <div class="col-xs-6">
            <p>
              <strong>NF Referência Nº:</strong> {{ stock.invoice }}
              <br>
              <strong>Data de emissão:</strong> {{ stock.dateInvoice | moment('LL') }}
            </p>
          </div>
          <div class="col-xs-6">
            <p>
              <strong>NF Referência Nº:</strong> {{ stock.invoicePowerCompany }} <br>
              <strong>Data de emissão:</strong> {{ stock.dateInvoicePowerCompany | moment('LL') }}
            </p>
          </div>
        </div>

        <h6>Destinatário</h6>
        <div class="row">
          <div class="col-xs-6">
            <p>
              <strong>Nome:</strong> {{ customer.holder }}<br>
              <strong>CPF:</strong> {{ customer.cpf }}<br>
              <strong>UC:</strong> {{ customer.uc }} <br>
              <strong>Telefone:</strong> {{ customer.phones.join(', ')
                                     }}
            </p>
          </div>
          <div class="col-xs-6">
            <p>
              <strong> Endereço: </strong>
              {{ customer.address.street }},
              {{ customer.address.number }}, {{
              customer.address.complement }} <br>
              <strong>Bairro:</strong> {{ customer.address.neighborhood
              }} <br>
              <strong>Município:</strong> {{ customer.address.city }}
              <br>
              <strong>CEP:</strong> {{ customer.address.zip }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h6>{{ stock.description }}</h6>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <p style="line-height: 1.5em">
              {{ manufacturer.informativeText }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4"><strong>Data de Recebimento</strong></div>
          <div class="col-xs-7 col-xs-offset-1"><strong>Identificação e Assinatura</strong>
          </div>
        </div>
        <div
          class="row"
          style="margin-bottom: 10px;"
        >
          <div
            class="col-xs-4"
            style="border-bottom: 2px solid black"
            :style="config.event.autoDateOnDeliveryTerm && dateTimeDelivery ? 'margin-top: 10px;' : 'margin-top: 30px;'"
          >
            {{ config.event.autoDateOnDeliveryTerm ? $moment(dateTimeDelivery.toISOString()).format('DD/MM/YYYY') : '' }}
          </div>
          <div
            class="col-xs-7 col-xs-offset-1"
            style=" margin-top: 30px; border-bottom: 2px solid black"
          ></div>
        </div>

      </div>
    </div>
    <div
      v-if="i === 1"
      class="row"
      style="border: 1px dashed black; width: 100%; margin: 10px 0px 10px 0px;"
    ></div>
  </div>

</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import HeaderTerm from '../HeaderTerm'

export default {
  name: 'delivery-term-celpa-jurunas',

  components: {
    HeaderTerm
  },

  props: {
    ticket: {
      required: true,
      type: Object
    },
    manufacturer: {
      required: true
    },
    config: {
      required: true
    },
    stock: {
      required: true
    },
    customer: {
      required: true
    },
    dateTimeDelivery: {
      required: true
    }
  },

  computed: {
    ...mapGetters('project', ['project', 'urlImages']),
    stateName: function () {
      return 'Pará'
    },
    fullname: function () {
      return this.longname + ' - ' + this.abbreviation
    },
    longname: function () {
      return 'As Centrais Elétricas do Pará S.A'
    },
    abbreviation: function () {
      return 'CELPA'
    },
    projectName: function () {
      return this.project.name
    },
    fulladdress: function () {
      return `${this.address.type} ${this.address.street}, nº ${this.address.number} – ${this.address.neighborhood}, ${this.address.city}/${this.address.state}`
    },
    address: function () {
      return {
        type: 'Rodovia',
        street: 'Augusto Montenegro',
        number: 'Km 8,5',
        neighborhood: 'Coqueiro',
        city: 'Belém',
        state: 'PA'
      }
    },
    cnpj: function () {
      return '04.895.728/0001-80'
    },
    numberState: function () {
      return '0144046'
    }
  },

  mounted () {
    this.getImagesProject()
  },

  methods: {
    ...mapActions('project', ['getImagesProject'])
  }
}
</script>
<style scoped>
  p, li {
    font-size: 10pt;
    text-align: justify;
  }

  table {
    border-spacing: 0.5rem;
    width: 100%;
  }

  td, th {
    text-align: center;
    border: 1px solid #999;
    padding: 0.5rem;
  }

  th {
    background-color: #ddd;
  }

  td {
    padding-bottom: 2cm;
    width: 25%;
  }

  @page {
    size: auto;   /* auto is the current printer page size */
    margin: 1cm;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/CelpaJurunas/DeliveryTermCelpaJurunas.vue